<template>
    <div class='container-fluid p-0 d-flex auth-bg justify-content-center align-items-center min-vh-100 w-100 position-relative'>
        <transition @enter="enter" @leave="leave">
        <AuthShell v-if="this.stage == 'registration'" :brand="this.regBrand" :trust="this.trustItems">
            <template #lang><LangSwitcher :type="'auth'"/></template>
            <template #brand-logo><BrandLogo /></template>
            <Registration @updateParentState="this.backStage()"/>
        </AuthShell>
        </transition>
        <transition @enter="enterA" @leave="leaveA">
        <AuthShell v-if="this.stage != 'registration'" :brand="this.brandCopy" :trust="this.trustItems">
            <template #lang><LangSwitcher :type="'auth'"/></template>
            <template #brand-logo><BrandLogo /></template>

            <!-- A1 — вход -->
            <div v-if="this.stage == 'auth'" key="st-auth" class="auth-form">
                <div class="form-head">
                    <h1 class="form-title">{{ $t('views.Login.1') }}</h1>
                    <p class="form-sub">{{ $t('views.Login.43') }}</p>
                </div>
                <div class="field">
                    <div class="field-label-row"><label class="field-label" for="cabinet_login">{{ $t('views.Login.2') }}</label></div>
                    <InputSimple id="cabinet_login" :autocomplete="'username'" autofocus @keyup="this.next" @updateParentState="this.updateState"/>
                </div>
                <div class="field">
                    <div class="field-label-row">
                        <label class="field-label" for="pass">{{ $t('views.Login.3') }}</label>
                        <a class="field-link" id="v-l-1" v-on:click='() => {this.stage = "recover"}'>{{ $t('views.Login.4') }}</a>
                    </div>
                    <InputSimple ref="pass" type='password' id="pass" :autocomplete="'current-password'" @keyup="this.onPassKey" @updateParentState="this.updateState"/>
                    <div v-if="this.caps" class="caps"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v6M12 16.5v.01"/></svg>{{ $t('views.Login.51') }}</div>
                </div>
                <div v-if="this.loginError" role="alert" class="field-msg" style="margin-bottom:10px"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v6M12 16.5v.01"/></svg>{{ this.loginError }}</div>
                <Button :name="$t('views.Login.15')" id="v-l-2" :style='"width: 100%"' type='btn-warning' :loader='this.loadingLogin' v-on:click="this.login"/>
                <!-- Google Identity Services: кнопку GIS отрисовывает сам Google в googleBtn (см. initGoogle). -->
                <div v-show="this.googleEnabled" class="google-auth">
                    <div class="google-sep"><span>{{ $t('views.Login.81') }}</span></div>
                    <div ref="googleBtn" class="google-btn"></div>
                </div>
                <!-- GitHub: server-side OAuth2. В отличие от Google (GIS рисует кнопку сам)
                     здесь SDK нет — своя кнопка уводит на github.com/login/oauth/authorize,
                     код возвращается на этот же роут и разбирается в handleGithubCallback.
                     Отдельный разделитель не нужен: блок идёт сразу под google-sep. -->
                <div v-show="this.githubEnabled" class="github-auth">
                    <button type="button" class="github-btn" :disabled="this.githubBusy" v-on:click="this.startGithubLogin">
                        <svg viewBox="0 0 16 16" aria-hidden="true"><path fill="currentColor" d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82a7.6 7.6 0 0 1 4 0c1.53-1.03 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.28.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8 8 0 0 0 16 8c0-4.42-3.58-8-8-8Z"/></svg>
                        <span>{{ $t('views.Login.82') }}</span>
                    </button>
                </div>
                <div class="form-foot">{{ $t('views.Login.5') }} <span v-on:click="this.stage = 'registration'" id="v-l-3" class="accent-link ml-1">{{ $t('views.Login.6') }}</span></div>
            </div>

            <!-- A2 — восстановление -->
            <div v-if="this.stage == 'recover'" key="st-recover" class="auth-form">
                <div class="form-head">
                    <h1 class="form-title">{{ $t('views.Login.7') }}</h1>
                    <p class="form-sub">{{ $t('views.Login.44') }}</p>
                </div>
                <div class="field">
                    <div class="field-label-row"><label class="field-label" for="info">{{ $t('views.Login.8') }}</label></div>
                    <InputSimple id="info" autofocus @updateParentState="this.updateState"/>
                    <div v-if="this.recoverError" role="alert" class="field-msg"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v6M12 16.5v.01"/></svg>{{ this.recoverError }}</div>
                </div>
                <div class="btn-row">
                    <Button :name="$t('views.Login.16')" id="v-l-4" type='btn-outline-warning flex-none' v-on:click='() => {this.stage = "auth"}'/>
                    <Button :name="$t('views.Login.18')" id="v-l-5" :disabled='this.data.info.length < 1 ? true : false' type='btn-warning flex-grow' :loader='this.loadingResetCode' v-on:click="this.send_reset_code"/>
                </div>
                <div class="form-foot">{{ $t('views.Login.5') }} <span v-on:click="this.stage = 'registration'" class="accent-link ml-1">{{ $t('views.Login.6') }}</span></div>
            </div>

            <!-- A3 — код подтверждения + новый пароль -->
            <div v-if="this.stage == 'reset' && !this.resetDone" key="st-reset" class="auth-form">
                <div class="form-head">
                    <h1 class="form-title">{{ $t('views.Login.30') }}</h1>
                    <p class="form-sub">{{ $t('views.Login.45') }}</p>
                </div>
                <div class="field">
                    <div class="field-label-row"><label class="field-label">{{ $t('views.Login.31') }}</label></div>
                    <OtpInput :value="this.data.confirm_code" @update:value="this.onCode"/>
                    <p v-if="this.maskedInfo" class="code-hint">{{ $t('views.Login.62') }} <b>{{ this.maskedInfo }}</b></p>
                </div>
                <div class="field">
                    <div class="field-label-row"><label class="field-label" for="new_password">{{ $t('views.Login.32') }}</label></div>
                    <InputSimple type='password' id="new_password" :autocomplete="'new-password'" :dataValue='this.data.new_password' @updateParentState="this.updateState"/>
                    <PasswordMeter :value="this.data.new_password" @update:valid="(v) => this.pwValid = v"/>
                </div>
                <div class="field">
                    <div class="field-label-row"><label class="field-label" for="new_password_repeat">{{ $t('views.Login.33') }}</label></div>
                    <InputSimple type='password' id="new_password_repeat" :autocomplete="'new-password'" :dataValue='this.data.new_password_repeat' @updateParentState="this.updateState"/>
                    <div v-if="this.data.new_password_repeat.length" class="match-msg" :class="this.resetMatch ? 'ok' : 'bad'">
                        <svg v-if="this.resetMatch" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7"/></svg>
                        <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v6M12 16.5v.01"/></svg>
                        {{ this.resetMatch ? $t('views.Login.61') : $t('views.Login.35') }}
                    </div>
                </div>
                <div v-if="this.resetError" role="alert" class="field-msg" style="margin-bottom:8px"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v6M12 16.5v.01"/></svg>{{ this.resetError }}</div>
                <div class="btn-row">
                    <Button :name="$t('views.Login.16')" id="v-l-6" type='btn-outline-warning flex-none' v-on:click='() => {this.stage = "recover"}'/>
                    <Button :name="$t('views.Login.34')" id="v-l-7" type='btn-warning flex-grow' :disabled="!this.resetCanSubmit" :loader='this.loadingReset' v-on:click="this.do_reset_password"/>
                </div>
            </div>

            <!-- A3-done — пароль обновлён -->
            <div v-if="this.stage == 'reset' && this.resetDone" key="st-reset-done" class="auth-form is-result">
                <div class="auth-ok-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7"/></svg></div>
                <div class="form-head">
                    <h1 class="form-title">{{ $t('views.Login.63') }}</h1>
                    <p class="form-sub">{{ $t('views.Login.64') }}</p>
                </div>
                <Button :name="$t('views.Login.65')" type='btn-warning' :style='"width: 100%"' v-on:click="this.afterResetDone"/>
            </div>
        </AuthShell>
        </transition>
    </div>
</template>

<script>
import InputSimple from '@/components/service/InputSimple';
import Button from '@/components/service/Button';
import Registration from '@/components/service/Registration';
import { gsap } from "gsap";
import LangSwitcher from '@/components/service/LangSwitcher';
import AuthShell from '@/components/service/AuthShell';
import BrandLogo from '@/components/service/BrandLogo';
import OtpInput from '@/components/service/OtpInput';
import PasswordMeter from '@/components/service/PasswordMeter';
import {
    generateGithubState as buildGithubState,
    buildGithubAuthorizeUrl,
    stripGithubOauthParams as computeStrippedGithubUrl,
    runGithubCallback,
} from '@/utils/githubOAuth';

export default {
    components: {
        InputSimple,
        Button,
        Registration,
        LangSwitcher,
        AuthShell,
        BrandLogo,
        OtpInput,
        PasswordMeter
    },
    data() {
        return {
            data: {
                cabinet_login: '',
                pass: '',
                info: '',
                confirm_code: '',
                new_password: '',
                new_password_repeat: '',
            },
            stage: 'auth',
            timeOut: false,
            continue: false,
            ask: false,
            user: false,
            resetError: '',
            safety: 0,
            caps: false,
            loginError: '',
            pwValid: false,
            resetDone: false,
            recoverError: '',
            // Точечные лоадеры сабмитов (mini-спиннер на кнопке вместо глобального оверлея).
            loadingLogin: false,
            loadingResetCode: false,
            loadingReset: false,
            // Google Identity Services: флаг готовности (показывать блок только если client_id задан и кнопка отрисована).
            googleEnabled: false,
            // Защита от повторной инициализации GIS (mounted + watch на config могут вызвать setupGoogle несколько раз).
            googleInited: false,
            // GitHub OAuth2 (server-side): своего SDK нет, нужен только флаг занятости
            // на время редиректа и обмена кода на сессию.
            githubBusy: false,
        }
    },
    mounted() {
        if (this.$store.state.isLogged) {
            this.$store.dispatch('logout', this.$router);
        }
        let b = document.querySelector('body');
        let w = document.querySelector('.wrapper');
        // Новый дизайн: страница светлая (page-bg из бренд-токенов),
        // водяная текстура — только в бренд-панели AuthShell.
        b.classList.remove('before-bg', 'after-bg');
        w.classList.remove('beforew-bg', 'afterw-bg');
        // Google Identity Services: client_id приходит рантаймом от PHP-бэка
        // (Auth::getConfig → isLogged → store PRE_CONFIG). На момент mounted он
        // может ещё не прийти — тогда setupGoogle выйдет, а watch на config вызовет
        // повторно, как только client_id появится.
        this.setupGoogle();
        // Возврат от GitHub приходит на этот же роут с ?code= — разбираем сразу.
        this.handleGithubCallback();
    },
    created() {
        if (this.$route.path == '/reg') {
            this.stage = 'registration';
        }
    },
    watch: {
        // config прилетает асинхронно (isLogged в App.vue) — инициализируем GIS после его прихода.
        '$store.state.config'() {
            this.setupGoogle();
        },
    },
    beforeUnmount() {
        let b = document.querySelector('body');
        let w  =document.querySelector('.wrapper');
        b.classList.remove('before-bg');
        b.classList.add('after-bg');
        w.classList.remove('beforew-bg');
        w.classList.add('afterw-bg');
    },
    computed: {
        // Копия бренд-панели по стадии. База числовых ключей: auth=66, recover=69, reset=72 (eyebrow/headline/lead = base/+1/+2).
        brandCopy() {
            const base = this.stage === 'recover' ? 69 : this.stage === 'reset' ? 72 : 66;
            return {
                eyebrow: this.$t(`views.Login.${base}`),
                headline: this.$t(`views.Login.${base + 1}`),
                lead: this.$t(`views.Login.${base + 2}`),
            };
        },
        trustItems() {
            return [
                this.$t('views.Login.75'),
                this.$t('views.Login.76'),
                this.$t('views.Login.77'),
            ];
        },
        regBrand() {
            return {
                eyebrow: this.$t('views.Login.78'),
                headline: this.$t('views.Login.79'),
                lead: this.$t('views.Login.80'),
            };
        },
        // Google client_id: основной источник — рантайм-конфиг от PHP-бэка
        // (store.config.GOOGLE_CLIENT_ID, задаётся per-env через processing-helm).
        // Фолбэк на build-time env оставлен для совместимости/локали.
        googleClientId() {
            const cfg = this.$store.state.config;
            return (cfg && cfg.GOOGLE_CLIENT_ID) || process.env.VUE_APP_GOOGLE_CLIENT_ID || '';
        },
        // GitHub client_id — тот же источник, что и у Google: рантайм-конфиг от PHP-бэка
        // (store.config.GITHUB_CLIENT_ID, задаётся per-env через processing-helm),
        // фолбэк на build-time env.
        githubClientId() {
            const cfg = this.$store.state.config;
            return (cfg && cfg.GITHUB_CLIENT_ID) || process.env.VUE_APP_GITHUB_CLIENT_ID || '';
        },
        // Блок показываем только когда client_id известен — без него редирект не собрать.
        githubEnabled() {
            return !!this.githubClientId;
        },
        // Маска контакта, на который ушёл код (#9): a••••@x.com / •••• ••• 12
        maskedInfo() {
            const v = (this.data.info || '').trim();
            if (!v) return '';
            if (v.includes('@')) {
                const [u, d] = v.split('@');
                const head = u.slice(0, Math.min(2, u.length));
                return head + '•'.repeat(Math.max(2, u.length - 2)) + '@' + d;
            }
            const digits = v.replace(/\D/g, '');
            return '•••• ••• ' + digits.slice(-2);
        },
        resetMatch() {
            return this.data.new_password.length > 0 && this.data.new_password === this.data.new_password_repeat;
        },
        resetCanSubmit() {
            // Минимум (как на бэке) — длина ≥5; чек-лист силы носит рекомендательный характер (#4).
            return this.data.confirm_code.length === 6 && this.data.new_password.length >= 5 && this.resetMatch;
        },
    },
    methods: {
        // Подключение GIS-скрипта (паттерн вставки DOM как в store/index.js).
        // Гейтится на googleClientId: пока client_id не пришёл от бэка — выходим;
        // watch на config вызовет повторно. Идемпотентно (googleInited).
        setupGoogle() {
            if (this.googleInited) return;
            if (!this.googleClientId) return;
            if (window.google && window.google.accounts && window.google.accounts.id) {
                this.initGoogle();
            } else if (!document.getElementById('gis-script')) {
                const s = document.createElement('script');
                s.src = 'https://accounts.google.com/gsi/client';
                s.async = true;
                s.defer = true;
                s.id = 'gis-script';
                s.onload = () => { this.initGoogle(); };
                document.head.appendChild(s);
            } else {
                // Скрипт уже добавлен другим экземпляром, но мог ещё не загрузиться — дождёмся onload.
                document.getElementById('gis-script').addEventListener('load', () => { this.initGoogle(); });
            }
        },
        // Инициализация Google Identity Services и отрисовка кнопки в контейнер googleBtn.
        // Вызывается из setupGoogle() (если GIS уже есть) или из onload динамического скрипта.
        initGoogle() {
            if (this.googleInited) return;
            const clientId = this.googleClientId;
            if (!clientId) return;
            if (!(window.google && window.google.accounts && window.google.accounts.id)) return;
            if (!this.$refs.googleBtn) return;
            window.google.accounts.id.initialize({
                client_id: clientId,
                callback: this.onGoogleCredential,
            });
            // Ширину кнопки подгоняем под форму; GIS требует число (px).
            const width = this.$refs.googleBtn.offsetWidth || (this.$store.state.isMobile ? 280 : 360);
            window.google.accounts.id.renderButton(this.$refs.googleBtn, {
                theme: 'outline',
                size: 'large',
                width: width,
            });
            this.googleEnabled = true;
            this.googleInited = true;
        },
        // Колбэк GIS с credential (id_token). Обработка ответа — как в login():
        // commit USER_DATA → редирект/2FA подхватятся автоматически; голый result!=0 без флагов — инлайн.
        onGoogleCredential(response) {
            const credential = response && response.credential;
            if (!credential) return;
            this.loginError = '';
            this.axios.post('loginGoogle', {no_loader: true, data: {id_token: credential}}).then(
                (res) => {
                    const body = res.data.body || {};
                    this.$store.commit('USER_DATA', body);
                    if (body.result != undefined && body.result != 0 && !res.data.error && !res.data.modal) {
                        this.loginError = body.result_text || this.$t('views.Login.47');
                    }
                }
            );
        },
        // Криптостойкий state для CSRF-защиты OAuth (взамен Math.random()+timestamp).
        generateGithubState() {
            return buildGithubState();
        },
        // Убирает только OAuth-параметры (code/state/error/error_description) из query,
        // остальную часть URL (прочие query-параметры, hash) сохраняет как есть.
        stripGithubOauthParams() {
            window.history.replaceState({}, document.title, computeStrippedGithubUrl(window.location.href));
        },
        // Старт server-side OAuth2: уводим на GitHub. state кладём в sessionStorage
        // и сверяем на возврате — защита от подменённого колбэка (CSRF).
        // Если sessionStorage недоступен (приватный режим / квота) — state сверить
        // на возврате будет не с чем, поэтому редирект не начинаем и показываем ошибку.
        startGithubLogin() {
            const clientId = this.githubClientId;
            if (!clientId || this.githubBusy) return;
            const state = this.generateGithubState();
            try {
                sessionStorage.setItem('github_oauth_state', state);
            } catch (e) {
                this.loginError = this.$t('views.Login.47');
                return;
            }
            this.githubBusy = true;
            window.location.href = buildGithubAuthorizeUrl({
                clientId,
                redirectUri: window.location.origin + window.location.pathname,
                scope: 'user:email',
                state,
            });
        },
        // Возврат от GitHub: ?code=&state= (успех) либо ?error=&state=&error_description= (отказ/сбой).
        // Оркестрация (проверка state для ЛЮБОЙ ветки, обмен code на сессию) вынесена в
        // runGithubCallback — чистая async-функция, тестируемая без монтирования компонента.
        handleGithubCallback() {
            return runGithubCallback({
                search: window.location.search,
                readSavedState: () => {
                    try { return sessionStorage.getItem('github_oauth_state'); } catch (e) { return null; }
                },
                clearSavedState: () => {
                    try { sessionStorage.removeItem('github_oauth_state'); } catch (e) { /* см. выше */ }
                },
                stripUrl: () => this.stripGithubOauthParams(),
                post: (code) => this.axios.post('loginGithub', {no_loader: true, data: {code: code}}),
                onLogin: (res) => {
                    const body = res.data.body || {};
                    this.$store.commit('USER_DATA', body);
                    if (body.result != undefined && body.result != 0 && !res.data.error && !res.data.modal) {
                        this.loginError = body.result_text || this.$t('views.Login.47');
                    }
                },
                onError: (message) => { this.loginError = message; },
                setBusy: (busy) => { this.githubBusy = busy; },
                genericErrorMessage: this.$t('views.Login.47'),
            });
        },
        login() {
            // Локальные ошибки — инлайн у формы (#6); ошибки бэка остаются тостом (axios-перехватчик).
            this.loginError = '';
            if (!this.data.cabinet_login || !this.data.pass) {
                this.loginError = this.$t('views.Login.20');
                return;
            }
            if (this.data.pass.length < 6) {
                this.loginError = this.$t('views.Login.21');
                return;
            }
            this.loadingLogin = true;
            this.axios.post('login', {no_loader: true, data: {cabinet_login: this.data.cabinet_login, password: this.data.pass}}).then(
                (res) => {
                    const body = res.data.body || {};
                    this.$store.commit('USER_DATA', body);
                    // Закрытие пробела: голый result!=0 без флагов error/modal — показываем инлайн (напр. «DKCP unavailable»).
                    if (body.result != undefined && body.result != 0 && !res.data.error && !res.data.modal) {
                        this.loginError = body.result_text || this.$t('views.Login.47');
                    }
                }
            ).finally(() => { this.loadingLogin = false; });
        },
        updateState(state) {
            this.data[state.id] = state.value;
            if (state.id === 'cabinet_login' || state.id === 'pass') {
                this.loginError = '';
            }
            if (state.id === 'info') {
                this.recoverError = '';
            }
        },
        count_pass_safety() {
            const value = this.data.new_password || '';
            let safety = 0;
            let max_safety = value.length >= 5 ? 100 : 20;
            safety = value.length * 5;
            for (let i = 1; i < value.length; i++) {
                if (value.charAt(i) === value.charAt(i - 1)) safety -= 4;
            }
            if (safety > 50) safety = 50;
            if (/[A-Z]/.test(value)) safety += 25;
            if (/[a-z]/.test(value)) safety += 25;
            if (/[0-9]/.test(value)) safety += 25;
            safety -= 25;
            if (/[_\-.!@$%^*=#~]/.test(value)) safety += 15;
            if (safety < 0) safety = 0;
            if (safety > 100) safety = 100;
            this.safety = Math.min(max_safety, safety);
        },
        next(e) {
            if (e.keyCode === 13) {
                this.$refs.pass.focusInput();
            }
        },
        submit(e) {
            if (e.keyCode === 13) {
                this.login();
            }
        },
        onPassKey(e) {
            if (e && typeof e.getModifierState === 'function') {
                this.caps = e.getModifierState('CapsLock');
            }
            if (e.keyCode === 13) this.login();
        },
        send_reset_code() {
            // #2 — валидируем формат до запроса (иначе письмо «уходит» на мусор).
            this.recoverError = '';
            const v = (this.data.info || '').trim();
            const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
            const isPhone = /^[+]?[\d\s()-]{7,}$/.test(v) && v.replace(/\D/g, '').length >= 7;
            if (!isEmail && !isPhone) {
                this.recoverError = this.$t('views.Login.46');
                return;
            }
            this.loadingResetCode = true;
            this.axios.post('forgotPassword', {
                no_loader: true,
                data: {login: this.data.info}
            }).then(() => {
                this.resetError = '';
                this.stage = 'reset';
            }).finally(() => { this.loadingResetCode = false; });
        },
        do_reset_password() {
            // Готовность гарантируют OtpInput (6 цифр) + PasswordMeter (требования) + match.
            if (!this.resetCanSubmit) return;
            this.resetError = '';
            this.loadingReset = true;
            this.axios.post('resetPassword', {
                no_loader: true,
                data: {
                    login: this.data.info,
                    confirm_code: this.data.confirm_code,
                    new_password: this.data.new_password,
                }
            }).then(res => {
                const body = res.data.body || {};
                if (body.result == '0' || body.result === 0) {
                    this.resetDone = true;
                } else if (!res.data.error && !res.data.modal) {
                    // Как в login: голый result!=0 без флагов error/modal — инлайн; иначе ошибку уже показал тост/модалка (без дубля).
                    this.resetError = this.extract_error(body) || this.$t('views.Login.36');
                }
            }).catch(err => {
                const body = err?.response?.data?.body || {};
                this.resetError = this.extract_error(body) || this.$t('views.Login.36');
            }).finally(() => { this.loadingReset = false; });
        },
        onCode(v) {
            this.data.confirm_code = v;
            this.resetError = '';
        },
        afterResetDone() {
            this.resetDone = false;
            this.pwValid = false;
            this.data.confirm_code = '';
            this.data.new_password = '';
            this.data.new_password_repeat = '';
            this.stage = 'auth';
        },
        extract_error(body) {
            if (!body) return '';
            if (typeof body.result_text === 'string') return body.result_text;
            return '';
        },
        backStage() {
            this.data = {
                cabinet_login: '',
                pass: '',
                info: '',
                confirm_code: '',
                new_password: '',
                new_password_repeat: '',
            };
            this.stage = 'auth';
            this.timeOut = false;
            this.continue = false;
            this.response = false;
            this.user = false;
            this.resetError = '';
            this.safety = 0;
            this.resetDone = false;
            this.pwValid = false;
        },
        reducedMotion() {
            return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        },
        enter(el) {
            if (this.reducedMotion()) return;
            gsap.fromTo(el, {opacity: 0.5, x: '-80%'}, {opacity: 1, x: '0', duration: 0.7});
        },
        leave(el, done) {
            if (this.reducedMotion()) { done(); return; }
            gsap.fromTo(el, {opacity: 1, x: '0'}, {opacity: 0.1, x: '-80%', duration: 0.7, position: 'absolute', onComplete: done});
        },
        enterA(el) {
            if (this.reducedMotion()) return;
            gsap.fromTo(el, {opacity: 0.5, x: this.$store.state.resize.w > 767 ? '+5%': '+10%'}, {opacity: 1, x: '0', duration: 0.7});
        },
        leaveA(el, done) {
            if (this.reducedMotion()) { done(); return; }
            gsap.fromTo(el, {opacity: 1, x: '0'}, {opacity: 0.1, x: '+200%', duration: 0.7, position: 'absolute', onComplete: done});
        },
    }
}
</script>

<style lang="scss">
.auth-logo {
    max-width: min-content;
}
.auth-bg {
    // background-image: url($bg-image);
    // background-repeat: no-repeat;
    // background-size: cover;
    // background-clip: padding-box;
    overflow-x: hidden;
    text-overflow: ellipsis;
    position: relative;
}
.auth-container {
    .content {
        padding: 1rem 1.3rem;
    }
    .alt-mb {
        margin-bottom: 0.6rem;
    }
}
.auth-width {
    max-width: 465px;
}
.auth-ls {
    position: fixed;
    right: 0;
    top: 30%;
    background-color: $color-acent;
    border-radius: 12px 0 0 12px;
}
.google-auth {
    margin-top: 14px;
}
.google-sep {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
    color: #8a8f9c;
    font-size: 12px;
}
.google-sep::before,
.google-sep::after {
    content: "";
    flex: 1;
    height: 1px;
    background: rgba(0, 0, 0, 0.1);
}
.google-btn {
    display: flex;
    justify-content: center;
}
.github-auth {
    margin-top: 12px;
}
.github-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    padding: 10px 12px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    background: #ffffff;
    color: #24292f;
    font-size: 14px;
    cursor: pointer;
}
.github-btn:disabled {
    opacity: 0.6;
    cursor: default;
}
.github-btn svg {
    width: 18px;
    height: 18px;
}
</style>